import { adminConstants } from 'redux/constant/admin-constant';
import { alertActions } from './alert-actions';
import { history } from 'helper/history';
import { adminUserService } from 'services/adminUser';

export const adminUserActions = {
    login,
    logout,
    dashboard,
};


function login(email, password) {
    return dispatch => {
        dispatch(request({ email }));
        
        adminUserService.login(email, password)
            .then(
                user => {
                    dispatch(success(user));
                    history.push('/Admin/dashboard');
                    // history.go(0);
                },
                error => {
                    console.log('error login', error);
                    dispatch(failure(error));
                    dispatch(alertActions.error(error));
                }
            );
    };

    function request(email) { return { type: adminConstants.LOGIN_ADMIN_REQUEST, payload:email } }
    function success(user) { return { type: adminConstants.LOGIN_ADMIN_SUCCESS, payload:user } }
    function failure(error) { return { type: adminConstants.LOGIN_ADMIN_FAILURE, payload:error } }
}

function logout() {
    adminUserService.logout();
    return { type: adminConstants.LOGOUT_ADMIN };
}

function dashboard(){
    return dispatch => {
        dispatch(request());
        adminUserService.dashboard()
            .then(
                response => {
                    dispatch(success(response));
                    history.push('/Admin/dashboard');
                },
                error => {
                    dispatch(failure(error));
                    dispatch(alertActions.error(error));
                }
            );
    };

    function request() { return { type: adminConstants.GET_DASHBOARD_REQUEST } }
    function success(response) { return { type: adminConstants.GET_DASHBOARD_SUCCESS, payload:response } }
    function failure(error) { return { type: adminConstants.GET_DASHBOARD_FAILURE, payload:error } }
}



// WEBPACK FOOTER //
// ./src/redux/actions/admin-user-action.js